import { z } from 'zod';
/**
 * The "Akquisiteur": the partner-company employee who established a lead — the
 * contact the lead is linked to by the commission association. This is the
 * provision/QM anchor (which sales agent produced which contact).
 */ export const PartnerLeadAcquirerSchema = z.object({
    /** HubSpot contact-record id of the acquiring partner employee. */ contactId: z.string(),
    /** Display name of that employee (null if not resolvable). */ name: z.string().nullable(),
    /** The employee's role (HubSpot jobtitle), for the acquirer card. */ jobTitle: z.string().nullable()
});
/**
 * A single lead (HubSpot contact) reachable from the requesting partner company
 * via one of its employees' Contact-to-Contact commission association. The
 * association is a LABEL PAIR and the backend reads it from the employee's
 * side, where HubSpot names it after the lead ("Provisionskunde") rather than
 * after the acquirer. All HubSpot properties are optional/nullable because
 * contacts are populated from a CRM where any field may be empty.
 */ export const PartnerLeadSchema = z.object({
    contactId: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    email: z.string().nullable(),
    /**
   * Name of the lead's associated HubSpot company (the relationship), falling
   * back to the contact's free-text `company` property when no company is
   * linked. Prefer this over the raw text field for display.
   */ company: z.string().nullable(),
    /** Id of the lead's associated company — null when none; links to the detail. */ companyId: z.string().nullable(),
    jobTitle: z.string().nullable(),
    phone: z.string().nullable(),
    /** HubSpot lifecyclestage, e.g. "lead", "marketingqualifiedlead". */ lifecycleStage: z.string().nullable(),
    /** HubSpot hs_lead_status, e.g. "NEW", "IN_PROGRESS". */ leadStatus: z.string().nullable(),
    /** Custom property "kontaktbeziehung", e.g. "Potenzieller Kunde". */ relationship: z.string().nullable(),
    /** Custom property "datum_kontaktaufnahme_durch_partner" (ISO date). */ partnerContactDate: z.string().nullable(),
    /** HubSpot createdate (ISO datetime). */ createdAt: z.string().nullable(),
    /**
   * The partner employee who created this lead. null when the anchor can't be
   * resolved (e.g. the legacy single-contact partner mode, which has no
   * per-employee attribution).
   */ acquirer: PartnerLeadAcquirerSchema.nullable()
});

//# sourceMappingURL=partner.schema.js.map